import dayjs from 'dayjs';
import { isTimeBeforeOrEqual } from '../../../../utils/date';

export function validateLoadTime(val: { loadTimeStart: string; loadTimeEnd: string }) {
  return val.loadTimeStart === val.loadTimeEnd || isTimeBeforeOrEqual(val.loadTimeStart, val.loadTimeEnd);
}

export function isRecent(val: string) {
  return dayjs(val).isAfter(dayjs().subtract(3, 'month'));
}

export function isTomorrowOrAfter(val: string) {
  const parsed = dayjs(val);
  const startOfTomorrow = dayjs().add(1, 'day').startOf('day');
  return !parsed.isBefore(startOfTomorrow);
}
